import React from 'react'
import PropTypes from 'prop-types'

export default class ErrorList extends React.Component {
  static get propTypes () {
    return {
      error: PropTypes.instanceOf(Error),
    }
  }

  render () {
    const {error} = this.props

    let errors = []
    if (error) {
      errors = error.messages || [error.message]
    }

    const show = (errors.length !== 0)
    if (!show) return null

    return (
      <div className='errorDisplay'>
        <h3>Oops.</h3>
        <ol>
          {errors.map((error, i) => (<li key={i}>{error}</li>))}
        </ol>
      </div>
    )
  }
}
